// extracted by mini-css-extract-plugin
export default {"box":"HomeButton_box__RnU1y","link":"HomeButton_link__ofTq4"};